import { TEditor } from '@udecode/plate';
import { Editor, Text } from 'slate';

import { MARK_COMMENT_ID } from '.';

export const getCommentNodeEntry = (id: string, editor: TEditor) => {
  return Editor.nodes(editor, {
    at: [],
    mode: 'lowest',
    match: (n) => {
      if (Text.isText(n)) {
        const commentId = n[MARK_COMMENT_ID];
        if (commentId === id) {
          return true;
        }
      }
      return false;
    },
  }).next().value;
};
